export default __webpack_public_path__ + "static/8-660092b81aa11820ed016e7deeae3514.png";